import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  title,
  subtitle
`

export const fragment = (name = 'contactForm') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
